module.exports = __webpack_public_path__ + "img/HC1009-193.930f039e.jpg";